import { BrowserCacheLocation, InteractionType, IPublicClientApplication, LogLevel, PublicClientApplication } from '@azure/msal-browser';
import { environment } from '../environments/environment';
import { MsalGuardConfiguration, MsalInterceptorConfiguration } from '@azure/msal-angular';

export const extraQueryParameters = { 'countryCode': getCountryCode(environment.language), 'theme': 'light', 'ui_locales': environment.language };

function getCountryCode(language: string) {
  switch (language) {
    case 'sv':
      return 'SE';
    case 'nb':
      return 'NO';
    case 'da':
      return 'DK';
    case 'fi':
      return 'FI';
    default:
      return 'SE';
  }
}

export function msalInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: environment.b2c.clientId,
      authority: environment.b2c.authority,
      redirectUri: window.location.origin,
      postLogoutRedirectUri: window.location.origin,
      knownAuthorities: [environment.b2c.authorityDomain],
      navigateToLoginRequestUrl: false,
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage, // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
    },
    system: {
      loggerOptions: {
        loggerCallback: (logLevel: LogLevel, message: string) => {
          if(!environment.production){
            console.log(message)
          }
        },
        logLevel: LogLevel.Error,
        piiLoggingEnabled: false,
      },
    },
  });
}

export function msalGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      extraQueryParameters: extraQueryParameters,
      scopes: environment.b2c.mainServiceScopes,
    },
    loginFailedRoute: '/login-failed',
  };
}

export function msalInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();
  protectedResourceMap
    .set(environment.apiUrl, environment.b2c.mainServiceScopes)
    .set(environment.garageUrl, environment.b2c.garageServiceScopes)
    .set(environment.routeUrl, environment.b2c.routeServiceScopes)
    .set(environment.outcomeUrl, environment.b2c.outcomeServiceScopes)
    .set(environment.positionUrl, environment.b2c.iotFunctionsServiceScopes);

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap,
    authRequest: {
      extraQueryParameters: extraQueryParameters,
    }
  };
}
